import { Suspense } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import PageLoader from '../../components/loaders/PageLoader/PageLoader';
import SiteSeo from '../../components/Seo/SiteSeo';
import StudioFrame from '../../components/StudioFrame/StudioFrame';
import Footer from './Footer/Footer';
import Header from './Header/Header';

const Layout = () => {
    const { pathname } = useLocation();
    if (pathname === '/blog' || pathname.startsWith('/blog/')) {
        return <><SiteSeo /><StudioFrame activePath="/blog" contentId="blog-content"><Suspense fallback={<PageLoader />}><Outlet /></Suspense></StudioFrame></>;
    }
    if (/^\/(lessons|workbooks|worksheets)\/[^/]+\/?$/.test(pathname)) {
        const activePath = pathname.startsWith('/lessons/') ? '/lessons' : '/workbooks';
        return <><SiteSeo /><StudioFrame activePath={activePath} contentId="resource-content"><Suspense fallback={<PageLoader />}><Outlet /></Suspense></StudioFrame></>;
    }
    // Studio pages own their header, main landmark and footer.
    if (['/k6program', '/consultation', '/about', '/schedule', '/workbooks', '/worksheets', '/lessons'].includes(pathname.replace(/\/$/, ''))) {
        return (
            <>
                <SiteSeo />
                <Suspense fallback={<PageLoader />}><Outlet /></Suspense>
            </>
        );
    }
    return (
        <>
            <SiteSeo />
            <Header />
            <main className="main">
                <Suspense fallback={<PageLoader />}>
                    <Outlet />
                </Suspense>
            </main>
            <Footer />
        </>
    );
};

export default Layout;
